import { useParams, useNavigate } from 'react-router-dom';

import * as Constants from '../../utils/constants';

import React, { useState, useEffect } from "react";

import '../../assets/css/competitor_details.css';


function CompetitorDetails() {
    const { id } = useParams();

    return (
        <div className="competitor-details">
            <div className="left-card">


                <div className="competitor-info">
                    <h2>Competitor Information</h2>
                    <div className="competitor-row">
                        <div className="label-name">First Name</div>
                        <div className="competitor-value">{id}</div>
                    </div>
                    
                    <div className="competitor-row">
                        <div className="label-name">Last Name</div>
                        <div className="competitor-value">{id}</div>
                    </div>
                    <div className="competitor-row">
                        <div className="label-name">Email:</div>
                        <div className="competitor-value">{id}</div>
                    </div>
                    <div className="competitor-row">
                        <div className="label-name">DOB:</div>
                        <div className="competitor-value">{id}</div>
                    </div>
                  

                    <button className="update-button" >
                        Update Details
                    </button>

                </div>
            </div>

            <div className="right-card">


                <div className="competitor-info">
                    <h2>competitor Information</h2>
                    <div className="competitor-name">{id}</div>
                    <div className="competitor-email">{id}</div>
                    <div className="competitor-phone">{id}</div>
                    <div className="competitor-address">{id}</div>
                </div>
            </div>

        </div>
    );
}

export default CompetitorDetails;